import {
  faTableColumns,
  faClipboardList,
  faChartPie,
  faTruckFast,
  faBox,
  faUsers,
  faLeaf,
  faChartLine,
  faFileLines,
  faShieldHalved
} from "@fortawesome/free-solid-svg-icons";

import { hexToRgba } from "@aclymatepackages/converters";
import mainTheme from "@aclymatepackages/themes";

export const LIGHT_GREEN = hexToRgba(mainTheme.palette.secondary.light, 0.2);

export const NAVIGATOR_UPGRADE_PATH = "/explorer/upgrade";

export const sideNavGroups = [
  {
    items: [
      {
        title: "Dashboard",
        icon: faTableColumns,
        path: "/explorer/dashboard?view=dashboard"
      }
    ]
  },
  {
    label: "Measure",
    items: [
      {
        title: "Complete Estimate",
        icon: faClipboardList,
        path: "/explorer/emissions-survey"
      },
      {
        title: "My Footprint",
        icon: faChartPie,
        path: "/explorer/dashboard?view=footprint"
      }
    ]
  },
  {
    label: "Manage",
    items: [
      {
        title: "My Suppliers",
        icon: faTruckFast,
        path: "/explorer/dashboard?view=suppliers",
        pendingGate: "suppliers"
      },
      {
        title: "My Product BOM Requests",
        icon: faBox,
        path: "/explorer/dashboard?view=products",
        pendingGate: "products"
      },
      {
        title: "My Emissions Requests",
        icon: faUsers,
        path: "/explorer/dashboard?view=customers",
        pendingGate: "customers"
      }
    ]
  },
  { locked: true, label: "Plan", icon: faChartLine, previewKey: "plan" },
  { locked: true, label: "Report", icon: faFileLines, previewKey: "report" },
  { locked: true, label: "Certify", icon: faShieldHalved, previewKey: "certify" },
  {
    items: [
      { title: "Offsets", icon: faLeaf, path: "/explorer/dashboard/offsets" }
    ]
  }
];

export const PENDING_GATE_MESSAGES = {
  suppliers: "Unlocks when a supplier shares their emissions data with you.",
  products: "Unlocks when a customer sends you a BOM confirmation request.",
  customers: "Unlocks when a customer sends you an emissions request."
};

export const NAVIGATOR_PREVIEW = {
  plan: {
    title: "Plan",
    blurb:
      "Turn your footprint into a reduction strategy — available in Navigator.",
    features: [
      "Set science-based reduction targets",
      "Build multi-year reduction roadmaps",
      "Model what-if reduction scenarios",
      "Track initiatives against targets"
    ]
  },
  report: {
    title: "Report",
    blurb:
      "Generate audit- and stakeholder-ready emissions reports — available in Navigator.",
    features: [
      "Annual greenhouse-gas inventory reports",
      "Stakeholder-ready emissions disclosures",
      "Custom reporting templates",
      "Footprint trend reporting across years"
    ]
  },
  certify: {
    title: "Certify",
    blurb: "Get audit- and disclosure-ready — available in Navigator.",
    features: [
      "Audit-ready emissions reports",
      "Third-party verification prep",
      "Certification workflows (SBTi, CDP)",
      "Assurance documentation"
    ]
  }
};
